import styled from "styled-components/macro";

export const CampaignContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;

  .campaign-middle-wrapper {
    height: calc(100vh - 96px);
    overflow: auto;
    transition: all 0.3s ease;

    &.loading {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    /* custom scrollbar */
    &::-webkit-scrollbar {
      height: 8px;
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: var(--Neutral-300);
      border: 1px solid transparent;
      background-clip: content-box;
    }
  }

  .campaign-footer-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 100%;
  }

  /* tabs */
  .campaign-tabs-container {
    display: flex;
    flex-direction: column;
    gap: 24px;

    .tabs-header {
      display: flex;
      align-items: center;
      padding: 0 4px;
      /* gap: 2px; */

      .tab {
        padding: 10px;
        height: 40px;
        display: flex;
        align-items: center;
        gap: 2px;
        border-radius: 40px;
        width: fit-content;
        cursor: pointer;

        &.disabled {
          cursor: not-allowed;
        }

        .details {
          color: var(--Neutral-60);
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
          letter-spacing: -0.021px;
          padding: 0 4px;

          &.user-details {
            color: var(--Neutral-80);
          }
        }

        &.active {
          background: var(
            --Neutral-4,
            linear-gradient(
              0deg,
              rgba(31, 31, 31, 0.04) 0%,
              rgba(31, 31, 31, 0.04) 100%
            ),
            #fff
          );

          .tab-circle {
            color: var(--White-100);
            background: var(--Neutral-100);
          }

          .details {
            color: var(--Neutral-100);
            font-weight: 600;
            letter-spacing: -0.028px;
          }
        }

        &:hover {
          background: var(
            --Neutral-4,
            linear-gradient(
              0deg,
              rgba(31, 31, 31, 0.04) 0%,
              rgba(31, 31, 31, 0.04) 100%
            ),
            #fff
          );
        }

        .tab-circle {
          color: var(--Neutral-60);
          font-size: 12px;
          font-weight: 500;
          line-height: 16px;
          letter-spacing: -0.018px;
          border-radius: 16px;
          background: var(
            --Neutral-8,
            linear-gradient(
              0deg,
              rgba(31, 31, 31, 0.08) 0%,
              rgba(31, 31, 31, 0.08) 100%
            ),
            #fff
          );
          display: flex;
          width: 24px;
          height: 16px;
          justify-content: center;
          align-items: center;

          &.tab-circle-full {
            background: var(
              --Neutral-80,
              linear-gradient(
                0deg,
                rgba(31, 31, 31, 0.8) 0%,
                rgba(31, 31, 31, 0.8) 100%
              ),
              #fff
            );
          }
        }
      }

      .progress-line-wrapper {
        width: 60px;
        height: 2px;
        background-color: #ccc;
        margin: 0 10px;
        position: relative;

        .progress-line {
          position: absolute;
          height: 100%;
          background-color: #000;
          top: 0;
          left: 0;
          transition: width 0.3s;

          &.half {
            width: 50%;
          }

          &.full {
            width: 100%;
          }
        }
      }
    }

    .tab-content {
      .button-wrappers {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;

        button {
          width: 100%;
        }

        .next-btn {
          max-width: 100px;
        }
        .cancel-btn {
          max-width: 93px;
        }
        .prev-btn {
          max-width: 103px;
        }
        .create-btn {
          max-width: 183px;
        }
      }
    }
  }
`;

export const EditCampaignStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .details-info-wrapper {
    h2 {
      color: var(--Neutral-100);
      font-size: 20px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.03px;
      padding: 16px;
    }

    .user-details-content-wrapper {
      padding: 16px;
      display: flex;
      gap: 24px;
      align-items: flex-start;

      .user-details-content {
        display: flex;
        flex-direction: column;
        gap: 24px;
        width: 100%;

        &.disabled {
          cursor: not-allowed;
          pointer-events: none;
        }

        .user-details-single-content {
          display: flex;
          flex-direction: column;
          gap: 4px;
          max-width: 304px;
          width: 100%;

          .multiple-fields {
            display: flex;
            align-items: flex-end;
            gap: 4px;
          }

          h4 {
            color: var(--Neutral-60);
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: -0.018px;
          }

          .small-header {
            color: var(--Neutral-60);
            font-size: 12px;
            font-weight: 500;
            line-height: 16px;
            letter-spacing: -0.018px;
          }

          p {
            overflow: hidden;
            color: var(--Neutral-100);
            text-overflow: ellipsis;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: -0.014px;

            &.user-id {
              font-family: "DM Mono";
              font-weight: 500;
            }
          }
        }
      }

      &.approval {
        flex-direction: column;
        max-width: 470px;
      }

      &.request-details {
        width: 100%;
        padding-bottom: 70px;

        .user-details-content {
          &.isInfluencer {
            max-width: 468px;
          }

          .user-details-single-content {
            max-width: 100%;

            &.toggle-wrapper {
              gap: 8px;
            }

            &.platform {
              width: max-content;
            }

            &.high-deal {
              display: flex;
              width: max-content;
              gap: 4px;

              .radio-wrapper {
                display: flex;
                flex-direction: row;
                gap: 24px;
                padding: 4px 0;
              }
            }
          }
        }
      }
    }
  }
`;

export const DetailsWrapperStyles = styled.div`
  height: calc(100vh - 201px);
  overflow: auto;
  padding: 16px 16px 40px;
  display: flex;
  align-items: flex-start;
  gap: 24px;

  /* custom scrollbar */
  &::-webkit-scrollbar {
    height: 8px;
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: var(--Neutral-300);
    border: 1px solid transparent;
    background-clip: content-box;
  }

  .platform {
    width: max-content;

    h4 {
      color: var(--Neutral-60);
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
      letter-spacing: -0.018px;
    }
  }

  .left-side-wrapper {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .toggle-wrapper {
      gap: 8px;
      display: flex;
      flex-direction: column;
    }
  }

  .phone-number-wrapper {
    display: flex;
    align-items: flex-end;
    gap: 4px;

    button {
      border-radius: 12px;
    }
  }

  .right-side-wrapper {
    width: 50%;
    display: flex;
    flex-direction: column;
    gap: 24px;

    .multiple-fields {
      display: flex;
      align-items: flex-end;
      gap: 4px;
    }

    .common-fields {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .input-wrappers {
      display: flex;
      gap: 6px;
      align-items: flex-end;

      button {
        max-width: 101px;
        width: 100%;
        border-radius: 12px;
      }
    }
  }
`;
